<template lang="pug">
.text-editor-setting
  vue-editor.text-editor-setting__editor(
    v-model='inputValue',
    :placeholder='placeholder',
    :editorToolbar='customToolbar'
  )
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import '@/assets/css/vue2editor.css'

@Component
export default class TextEditorSetting extends Vue {
  // 入力値
  @Prop()
  value!: string

  // プレースホルダー（任意）
  @Prop()
  placeholder?: string

  // 入力値ゲッター・セッター
  get inputValue(): string {
    return this.value
  }
  set inputValue(value: string) {
    this.$emit('input', value)
  }

  /**
   * Vue2Editorツールバーカスタム設定
   * + 標準ツールバー設定
   *   [{ header: [false, 1, 2, 3, 4, 5, 6] }],
   *   ['bold', 'italic', 'underline', 'strike'], // toggled buttons
   *   [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
   *   ['blockquote', 'code-block'],
   *   [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
   *   [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
   *   [{ color: [] }, { background: [] }], // dropdown with defaults from theme
   *   ['link', 'image', 'video'],
   *   ['clean'], // remove formatting button
   */
  private customToolbar = ['bold', 'italic', 'link', 'blockquote', { list: 'bullet' }, { list: 'ordered' }]
}
</script>

<style lang="stylus" scoped>
.text-editor-setting
  display flex

  &__editor
    display flex
    flex-direction column
    width 510px
    gap 8px
</style>
